import { render, staticRenderFns } from "./baseDetail.vue?vue&type=template&id=401478a9&scoped=true&"
import script from "./baseDetail.vue?vue&type=script&lang=js&"
export * from "./baseDetail.vue?vue&type=script&lang=js&"
import style0 from "./baseDetail.vue?vue&type=style&index=0&id=401478a9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "401478a9",
  null
  
)

export default component.exports